const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://soumyajitdatta.com',
  title: 'SD.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Soumyajit Datta',
  role: 'PhD Student @ RIT',
  description:
    '<p>Hi, I am Soumyajit, a second-year PhD student at the Rochester Institute of Technology, advised by <a href="https://www.se.rit.edu/~axkvse/" target="_blank"><u>Dr. Ashique KhudaBukhsh</u></a> and <a href="https://www.rit.edu/directory/nxsvse-naveen-sharma" target="_blank"><u>Dr. Naveen Sharma</u></a>.  My research spans <a href="#"><i>Computational Social Science</i></a> and <a href="#"><i>AI Safety</i></a>, combining large-scale data analysis with critical evaluation of modern AI systems. In computational social science, I use <a href="#"><i>NLP</i></a>-based techniques to study legal documents, gender bias, and public responses to real-life events, often analyzing social media data to uncover trends in public discourse. In AI safety, my work focuses on <a href="#"><i>Large Language Models (LLMs)</i></a> and <a href="#"><i>Vision-Language Models (VLMs)</i></a>, addressing challenges such as intersectional bias, toxicity, and hallucinations. Through this dual focus, I aim to design AI systems that are both socially insightful and reliable for real-world applications.</p> <p>Outside of research, I enjoy playing chess and the piano, always seeking new intellectual and creative challenges. Occasionally, I write blogs, compete on Kaggle, or dive into discovering fascinating facts about dinosaurs or the universe.</p>',
  resume: 'https://soumyajitdatta.com',
  shortbio: 'MLE Intern',
  study: 'Apple',
  email: 'sd3528[at]rit[dot]edu',
  where: 'New York, USA',
  social: {
    linkedin: 'https://linkedin.com/in/codehackerone',
    github: 'https://github.com/codehackerone',
    google_scholar:
      'https://scholar.google.com/citations?user=haI2B0QAAAAJ&hl=en',
    twitter: 'https://x.com/soumyajit_dt',
    medium: 'https://medium.com/@soumyajitdatta123',
    hashnode: 'https://hashnode.com',
    kaggle: 'https://kaggle.com',
  },
}

const publications = [
  {
    year: '2026',
    authors:
      'Arka Dutta, Sujan Dutta, Rijul Magu, <b><u>Soumyajit Datta</u></b>, Munmun De Choudhury, Ashiqur R. KhudaBukhsh',
    title:
      'Truths, Lies, and Nudge. HAUNT: A Framework to Probe LLMs’ Self-consistency in Closed Domains Via Adversarial Nudge',
    link: 'https://arxiv.org/pdf/2511.08596',
    conference: 'ACL\'2026',
  },
  {
    year: '2025',
    authors:
      'Somonnoy Banerjee, Sujan Dutta, <b><u>Soumyajit Datta</u></b>, Ashiqur R. KhudaBukhsh',
    title:
      'Gender Representation and Bias in Indian Civil Service Mock Interviews',
    link: 'https://arxiv.org/abs/2409.12194',
    conference: 'arXiv (Under Review)',
  },
  // {
  //   year: '2025',
  //   authors:
  //     '<b><u>Soumyajit Datta</u></b>, Arka Dutta, Dhruv Vaidh, Sujan Dutta, Ashiqur R. KhudaBukhsh',
  //   title: 'Investigating Intersectionality in Large Language Models',
  //   link: '#',
  //   conference: 'Under Review',
  // },
  // {
  //   year: '2025',
  //   authors:
  //     'Aarav Lala, <b><u>Soumyajit Datta</u></b>, Ashiqur R. KhudaBukhsh',
  //   title: 'Does Ozempic Work? Investigating Social Web Stance',
  //   link: '#',
  //   conference: 'Under Review',
  // },
  {
    year: '2026',
    authors:
      '<b><u>Soumyajit Datta</u></b><sup>*</sup>, Miles Stanley<sup>*</sup>, Ashutosh Kumar, Ashiqur R. KhudaBukhsh',
    title: "Investigating Vaccine Buyer's Remorse",
    link: '#',
    conference: 'AAAI\'26: Proceedings of the AAAI Conference on Artificial Intelligence',
  },
  // {
  //   year: '2025',
  //   authors:
  //     '<b><u>Soumyajit Datta</u></b><sup>*</sup>, Prakhar Misra<sup>*</sup>, Devesh Kapur, Ashiqur R. KhudaBukhsh',
  //   title:
  //     'Law, Labor, and Language Models: Empirical Insights into Recruitment Litigation and State-Building in India',
  //   link: '#',
  //   conference: 'Under Review',
  // },
  {
    year: '2025',
    authors:
      'Soumilya De, <b><u>Soumyajit Datta</u></b>, Koustav Rudra, Saptarshi Ghosh, Ashiqur R. KhudaBukhsh, Kripabandhu Ghosh',
    title:
      'Justice for the Disadvantaged: A Study of Public Reactions on Indian Supreme Court Judgments',
    link: '#',
    conference:
      "ASONAM'25: The 17th International Conference on Advances in Social Networks Analysis and Mining",
  },
  {
    year: '2025',
    authors:
      '<b><u>Soumyajit Datta</u></b>, Jaysmito Mukherjee, Kousik Dasgupta',
    title:
      'Enhancing Intrusion Detection Systems with Conditional Adversarial Autoencoders for Class Imbalance Mitigation',
    link: '#',
    conference:
      "CICBA'25: Seventh International Conference on Computational Intelligence in Communications and Business Analytics",
  },
  {
    year: '2024',
    authors:
      'MTA Chowdhury, <b><u>Soumyajit Datta</u></b>, Naveen Sharma, Ashiqur R. KhudaBukhsh',
    title:
      'Infrastructure Ombudsman: Mining Future Failure Concerns from Structural Disaster Response',
    link: 'https://dl.acm.org/doi/abs/10.1145/3589334.3648153',
    conference: "WWW'24: Proceedings of the ACM Web Conference 2024",
  },
  {
    year: '2024',
    authors:
      '<b><u>Soumyajit Datta</u></b>, Arya Chakraborty, Saptarshi Bhattacharya, Amit Samui, Anurag Chakraborty, Kousik Dasgupta',
    title: 'Nirnayaak: Revolutionizing Legal Research',
    link: 'https://ieeexplore.ieee.org/abstract/document/10829440',
    conference:
      'C3IT 2024: 4th International Conference on Computer, Communication, Control & Information Technology',
  },
]
const blogs = [
  {
    title:
      'Decoding Toxicity in Large Language Models: A Journey Through Neural Circuits, Hidden Knowledge, and Detoxification',
    date: 'Feb 8, 2025',
    description:
      'Imagine standing in front of a vast, ancient library where each book whispers its contents into the air. Some books hold deep wisdom, others tell simple facts, and a few — hidden in the shadows — murmur dangerous, toxic words. This is how Large Language Models (LLMs) work: vast reservoirs of knowledge, structured but unpredictable, sometimes generating insights, other times echoing harmful biases. But where does this toxicity come from? Can we pinpoint the pages, the sentences, or even the words responsible for it? And once we find them, can we mute, rewrite, or erase them without destroying the rest of the library?',
    link: 'https://medium.com/@soumyajitdatta123/decoding-toxicity-in-large-language-models-a-journey-through-neural-circuits-hidden-knowledge-b24462f480a0',
    image:
      'https://miro.medium.com/v2/resize:fit:720/format:webp/1*s5039T69mafPYIrJ1ug-UQ.png',
  },
  {
    title: 'The Evolution of LLM Agents — From Text to Intelligent Action',
    date: 'Oct 2, 2024',
    description:
      'Let’s explore the fascinating journey of LLM agents, along with a fun nod to The Big Bang Theory because, after all, Sheldon Cooper would love talking about AI as much as string theory.',
    link: 'https://medium.com/@soumyajitdatta123/the-evolution-of-llm-agents-from-text-to-intelligent-action-0958e3c41f14',
    image:
      'https://miro.medium.com/v2/resize:fit:720/format:webp/1*3qndlMXbsO7iJgrQn92Ptw.png', // Replace with your image URL
  },
  {
    title:
      'Chain of Thought: Unraveling the Power and Limitations of Reasoning in Large Language Models',
    date: 'Sep 29, 2024',
    description:
      'In this post, we’ll explore how reasoning works in LLMs, the strategies that can enhance their reasoning abilities, and the key limitations they still face.',
    link: 'https://medium.com/@soumyajitdatta123/chain-of-thought-unraveling-the-power-and-limitations-of-reasoning-in-large-language-models-1e4228eb8803',
    image:
      'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*EKqmeeKRK-84M_yrsPmOsA.jpeg',
  },
  {
    title: 'The Magic of Graph Neural Networks: Jab Neural Networks Met Graphs',
    date: 'Apr 19, 2023',
    description:
      'A comprehensive guide to Graph Neural Networks (GNNs) and their applications in various domains.',
    link: 'https://medium.com/@soumyajitdatta123/the-magic-of-graph-neural-networks-jab-neural-networks-met-graphs-aa181468795f',
    image:
      'https://miro.medium.com/v2/resize:fit:720/format:webp/1*pj_qRWctMpYLBygPrs8AMQ.jpeg',
  },
  {
    title: 'Using Custom Datasets to train DETR for object detection',
    date: 'April 14, 2023',
    description:
      'How to train the DETR model for object detection using custom datasets and PyTorch.',
    link: 'https://medium.com/@soumyajitdatta123/using-custom-datasets-to-train-detr-for-object-detection-75a6426b3f4e',
    image:
      'https://miro.medium.com/v2/resize:fit:640/format:webp/1*u-qoEPM86RZGNqZHqCUQ3A.jpeg',
  },
  {
    title:
      'Introducing Nirnayaak: The AI behind Revolutionary Web Application Simplifying Legal Research',
    date: 'Apr 6, 2023',
    description:
      'Are you tired of sifting through piles of legal documents and case files, trying to find the information you need? Do you feel like you need a degree in law just to understand the jargon and legalese? Well, fret not, my friend! Nirnayaak is here to save the day!',
    link: 'https://soumyajitdatta.hashnode.dev/introducing-nirnayaak-the-ai-behind-revolutionary-web-application-simplifying-legal-research',
    image:
      'https://cdn.hashnode.com/res/hashnode/image/upload/v1680803214692/33ae947e-753c-4f3c-bef6-a2c9aa6dd715.webp?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp',
  },
]

const experience = [
  {
    title: 'Machine Learning Engineering Intern',
    organization: 'Apple',
    logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAMAAABC4vDmAAAAe1BMVEUAAAD////y8vL7+/vv8O/19fTt7e15e3ng4d/q6+klJiQKDQm/wL4UFRQICAibm5k3Oz5ERkNgYmCqrKo2NzZ/gH/T1NJJSkiMjoy3ubcsLCtsbWuFh4U/QT4gISBydHIaGxlTVFKjo6DIycgUFhCVlJZnZWexsLI/REYKW6azAAAC1klEQVR4nO2a23qiMBRGiRFMLEoVDVU8QtW+/xOOCtJ4YKjJ/MSvs9clucj6ctjJ3sTzCIIgCIIgCIIgCIIgiEeMxgPXCjcksQj4xLXFFVPFTixde2gkhdJLSX2wC68zfbPKyZ+7dikZfDsx9Sq7T3NisWuZkp7mxFPXNgVJoEkJ1zYloebEFq5tCpa6k1i51inQVznrubYpWErNaebapiTVJ6/v2qYk1pxeJZh7qnKSiWuXimpJha5NNDqFUmftUmI5Ttdpuq2WtDgZqUsomBxbe+l++dai0SZSkp9OuK4Ip8WnKMym28JhHuXCPx+AUmVtbcQ0Z1fkPe2WmSzkdatqY0LnM85ukeHiPCL9Rd69a2Qh/BK6vu+0gPvde9sS8PEc1/X7d5Bx4i1s7v8xCndtMHY6WqGcDOeuIN9AnKY2TiyDSE18CyWxRShZLShYFpg2d11LjspMVXPfdUiQkretDdeN+KD15HmZ+UB9oJxW5rPno5y8kflATWFS5ntP4kp6B2Mp4AXBfEkB71JBc+81AAuyD265PwSY0HRMnTjOafi7pNhLSn3irMylYKexze6DHcc2cSrHSZlH9AAXPS2yK9z8WaRXAUwqMZfCDdXEPCYwOQJJDfLmzmuB/T2yqiMcQFK1xbIfAfovMrSpJBxDKCZa2SyqIxKS1NjUEs6I9N9X8yayud8GAP+VrfbfCUTd0yJJLoBEdsul3kU4eXs7qR1Eamg1VKj/pVZDBUvfLYYK96TDvMbI9zApLzKVynBOxqkWJhxcGBtNIB9DpcwOG/gLL/G8E/4x1fbpFCIAlhMujJ+VasHp6bgArHDo7J5xau0hXHQbGLjM4yjKZuI2veAtjdOJ9CqIql2Vq3yur95SBMDT5Z7vdxw8v3l6/hVfhosf2n7e9R6FSqgw+rpv2ixmSogwem9Z6cyqX5sKbOqbCIIgCIIgCIIgCIIgCIIg/jP+AKuTJib/eTpPAAAAAElFTkSuQmCC',
    duration: 'May 2026 - Present',
    description:
      'Answers, Knowledge and Information (AKI)',
    keyPoints: [
      // 'Studying bias, robustness, and inconsistencies in LLMs and vision-language models (VLMs).',
      // 'Specializing in LLMs and disaster response systems.',
    ],
  },
  {
    title: 'Graduate Research Assistant',
    organization: 'Rochester Institute of Technology',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755101405/personal-website/rit_logo_jm4e7f.png',
    duration: 'Aug 2024 - Present',
    description:
      'Working on extracting social insights using NLP and computer vision techniques.',
    keyPoints: [
      'Studying bias, robustness, and inconsistencies in LLMs and vision-language models (VLMs).',
      // 'Specializing in LLMs and disaster response systems.',
    ],
  },
  {
    title: 'Research Intern',
    organization: 'Rochester Institute of Technology',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755101405/personal-website/rit_logo_jm4e7f.png',
    duration: 'August 2023 - Jul 2024 · 1 yr 1 mo',
    keyPoints: [
      'Collaborated on disaster response research, creating an infrastructure ombudsman to identify concerns from social web discussions.',
      'Developed a dataset of 2,662 instances from Reddit and YouTube, with robust baselines, enhancing disaster preparedness and infrastructure resilience; accepted at Web ’24 Conference.'
    ],
  },
  {
    title: 'Data Science Intern',
    organization: 'Kavida.ai',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755101991/personal-website/kavida_hrqc3r.jpg',
    // duration: 'Aug 2023 - May 2024',
    duration: '',
    keyPoints: [
      'Optimized Supplier Onboarding: Enhanced the supplier onboarding and craft pipelines using multiprocessing, improving efficiency and processing speed.',
      'Risk Analysis Automation: Benchmarked, implemented, and deployed LLM-powered responses for risk analysis, reducing manual verification processes by 70%.',
      'Business Signal Implementation: Developed and deployed an alternative method for adding business signals to articles using a tag mechanism, streamlining content categorization.',
      'Kavida Copilot Enhancement: Benchmarked and introduced two modules for Kavida Copilot in Langchain: Answering In-domain General Knowledge questions and question Classification.',
    ],
  },
  {
    title: 'Machine Learning Intern',
    organization: 'Aarish Technologies Inc.',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755101927/personal-website/aarish_tywlmk.jpg',
    duration: '',
    keyPoints: [],
  },
  {
    title: 'ML Research Intern, CICPS',
    organization: 'Indian Institute of Technology, Guwahati',
    duration: 'Sep 2022 - Sep 2023',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102020/personal-website/iitg_saetum.png',
    keyPoints: [
      'Used Generative Adversarial Networks (GANs) to create image features in breast ultrasound images to improve mAP(mean average precision) scores in object-detection models such as Faster-RCNNs and DETR.',
      'Color restoration of underwater images using super-resolution techniques by Convolutional Attention Modules.',
    ],
  },
  {
    title: 'Machine Learning Intern',
    organization: 'Zuma',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102183/personal-website/zuma_y61jqm.png',
    duration: 'Sep 2022 - Feb 2023',
    keyPoints: [
      'Developed a Paraphrasing Module using GPT-3 improving Kelsey’s conversations, achieving an SSA score of 93.5, and integrated it with the existing DialogManager Module.',
      'Conducted a literature review and implemented the Multi-Label Text Classification using Attention-based Graph Neural Network (MAGNET) paper, built training and test pipelines, resulting in a 6% improvement in results.',
      'Fine-tuned a transformer model to create an Empathy Model for Kelsey (AI Assistant), achieving a test accuracy of 0.81% and created a fastAPI module and exposed a testing endpoint.',
      'Shipped ML Models using Docker Containers in AWS Sagemaker and EC2 instances for production.',
    ],
  },
  {
    title: 'Back End Developer and Project Lead',
    organization: 'Tech Table',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102234/personal-website/techtable-dark-logo_dm0myj.png',
    duration: 'May 2021 - Nov 2021',
    keyPoints: [
      'Backend Web Development in NodeJS with MongoDB, Firebase.',
      'Projects with Google Drive, Sheet and OAuth2 APIs.',
      'Projects with Cloudinary, Twilio APIs, AWS RDS, and Postgres Server.',
      'Frontend Development with React.',
    ],
  },
  {
    title: 'ML Research Intern',
    organization: 'Jadavpur University',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102273/personal-website/ju_npfe3d.png',
    duration: 'Jul 2022 - Sep 2022',
    keyPoints: [
      'Enhanced the UNET architecture for skin lesion segmentation by incorporating spatial and channel attention mechanisms, resulting in notable performance improvements with IoU and DICE scores greater than most literature benchmarks.',
    ],
  },
  // {
  //   title: 'Machine Learning Intern',
  //   organization: 'InfyU LABS',
  //   logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102319/personal-website/infyu_lan05q.png',
  //   duration: 'Jun 2022 - Aug 2022',
  //   keyPoints: [
  //     'Spectroscopic Data Analysis with Classification and Regression Problems.',
  //     'Building ML automation applications using StreamLit.',
  //   ],
  // },
  {
    title: 'SDE Intern',
    organization: 'Hooley',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102409/personal-website/hooley_su3ke7.jpg',
    duration: 'Dec 2021 - Jun 2022',
    keyPoints: [
      'Development of frontend web application in React.',
      'Backend development with NodeJS, MongoDB.',
      'Used AWS S3 buckets, AWS SQS, AWS SES, IAM, and Twilio Messaging APIs.',
    ],
  },
  {
    title: 'Backend Engineer',
    organization: 'Glorio',
    logo: 'https://res.cloudinary.com/codehackerone/image/upload/v1755102409/personal-website/hooley_su3ke7.jpg',
    duration: 'May 2021 - May 2022',
    keyPoints: [
      'Development of frontend web application in React and backend development in NodeJS and MongoDB.',
      'Using AWS S3 buckets, AWS SES, AWS IAM, Twilio Messaging APIs.',
    ],
  },
]

const projects = [
  {
    name: 'SignSwift',
    description:
      'A real-time sign language detection system combining computer vision and NLP for live translation and interactive learning.',
    stack: ['Python', 'TensorFlow', 'Transformers', 'Flask', 'JavaScript'],
    sourceCode: 'https://github.com/Codehackerone/signswift',
    livePreview:
      'https://drive.google.com/file/d/19_KEb3MoLf1uHPmghhpchqeeb-I2nwnC/view?usp=sharing',
  },
  {
    name: 'Nirnayaak',
    description:
      'An AI-powered platform for efficient legal document retrieval, featuring OCR, spell check, keyword extraction, summarization, and secure authentication.',
    stack: ['Python', 'Flask', 'MongoDB', 'Cohere', 'AWS', 'Digital Ocean'],
    sourceCode: 'https://github.com/Codehackerone/nirnayaak.ai',
    livePreview: '',
  },
  {
    name: 'Parkify | FindMyGarage',
    description:
      'An AI-driven parking solution offering automatic license plate detection, optimized space allocation, and seamless in-app payments.',
    stack: [
      'NodeJS',
      'TypeScript',
      'ReactJS',
      'Python',
      'TensorFlow',
      'Google Maps API',
    ],
    sourceCode: 'https://github.com/Codehackerone/parkify',
    livePreview: 'https://github.com/FindMyGarage',
  },
  {
    name: 'InvoiceQnA',
    description:
      'A model that extracts data from invoice images and answers user queries using OCR and NLP techniques.',
    stack: ['Python', 'Flask', 'MongoDB', 'Streamlit', 'AWS'],
    sourceCode: 'https://github.com/Codehackerone/InvoiceQnA',
    livePreview: '',
  },
  {
    name: 'CaptchaVision',
    description:
      'A captcha recognition system utilizing the LACC deep learning model for accurate image-to-text translation.',
    stack: ['Python', 'PyTorch', 'FastAPI', 'JavaScript'],
    sourceCode: 'https://github.com/Codehackerone/CaptchaVision',
    livePreview: '',
  },
  {
    name: 'StoryForge',
    description:
      'A text-generation project that creates fictional stories using a GRU-based architecture trained on popular novels.',
    stack: ['Rust', 'Python', 'TensorFlow', 'Keras', 'gRPC'],
    sourceCode: 'https://github.com/Codehackerone/storyforge',
    livePreview: '',
  },
  {
    name: 'ColonAIzer',
    description:
      'A colon polyp detection tool employing a U-Net-based architecture for real-time segmentation.',
    stack: ['Python', 'TensorFlow', 'PyTorch', 'Flask', 'Tkinter'],
    sourceCode: 'https://github.com/Codehackerone/ColonAIzer',
    livePreview: '',
  },
  {
    name: 'BrainScope',
    description:
      'A comparative study of ViTs and CNNs for brain tumor classification and segmentation using MRI images.',
    stack: ['Python', 'PyTorch'],
    sourceCode: 'https://github.com/Codehackerone/BrainScope',
    livePreview: '',
  },
  {
    name: 'AluCast',
    description:
      'A time series analysis project forecasting aluminum prices using models from naive approaches to N-BEATS.',
    stack: ['Python', 'TensorFlow'],
    sourceCode: 'https://github.com/Codehackerone/Time-series-analysis',
    livePreview: '',
  },
  {
    name: 'Tessarus',
    description:
      'A backend system for a ticketing platform, enabling event management and secure attendee check-ins.',
    stack: ['NodeJS', 'TypeScript', 'MongoDB', 'AWS'],
    sourceCode: 'https://github.com/Codehackerone/tessarus',
    livePreview: '',
  },
  {
    name: 'Libraryly',
    description:
      'An online library management system facilitating efficient book and member management with GraphQL support.',
    stack: ['Rust', 'Neo4j', 'NodeJS', 'JavaScript', 'MongoDB', 'EJS'],
    sourceCode: 'https://github.com/Codehackerone/libraryly',
    livePreview: '',
  },
]

const skills = [
  // Core AI/ML
  'Machine Learning',
  'Deep Learning',
  'Natural Language Processing (NLP)',
  'Computer Vision',
  'Large Language Models (LLMs)',
  'LLM Evaluation',
  'Retrieval Augmented Generation (RAGs)',
  'Instruction Tuning',
  'RLHF',

  // Languages
  'Python',
  'Java',
  'JavaScript',
  'TypeScript',
  'Rust',

  // Frameworks & Libraries
  'PyTorch',
  'TensorFlow',
  'Hugging Face',
  'LangChain',

  // Systems & Tools
  'Docker',
  'Git',
  'Postgres',
  'MongoDB',

  // Cloud
  'AWS',
  'GCP',
  'Azure',

  // Frontend/Backend
  'React',
  'Node.js',
]
const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'soumyajitdatta123@gmail.com',
}

const highlights = [
  {
    heading: 'Publications',
    text: '	Published 6 papers in top AI conferences (ACL, AAAI, WWW)',
    link: '',
  },
  {
    heading: 'Reviewer Duties',
    text: 'Reviewer for WWW 2026, WWW 2025, IJCAI 2026, AAAI 2026.',
    link: '',
  },
  {
    heading: 'MLH Hackathon (Diversion 2k23)',
    text: 'Runners-Up (2nd overall); built a full-stack solution. Won $1500 prize.',
    link: '',
  },
  {
    heading: 'HackforBengal 2k23',
    text: 'State-level Runners-Up (2nd overall) with community-focused project. Won $1500 prize.',
    link: '',
  },
  {
    heading: 'LTTS TECHgium Hackathon',
    text: 'Pre-finalist; ranked Top 129 of 35,000+ teams nationwide.',
    link: '',
  },
  {
    heading: 'Smart India Hackathon 2022',
    text: 'Finalist in India’s largest national hackathon with AI-based solution.',
    link: '',
  },
  {
    heading: 'NSF-REU Mentor',
    text: 'Mentored undergraduates from UW and UMBC on NLP and AI safety.',
    link: '',
  },
  {
    heading: 'Code to PhD Mentor',
    text: 'Guiding underrepresented students preparing for PhD programs.',
    link: '',
  },
  // {
  //   "heading": "Invited Speaker",
  //   "text": "Delivered Google ExploreML workshops at Colman University, Israel, Hong Kong University of Management Studies, IERT, Prayagraj among others.",
  //   "link": ""
  // },
  // {
  //   "heading": "Kaggle 3× Expert",
  //   "text": "Earned expert level in Notebooks, Datasets, and Discussions.",
  //   "link": ""
  // },
  // {
  //   "heading": "Media Attention",
  //   "text": "Research and hackathon achievements featured in media outlets.",
  //   "link": ""
  // },
  // {
  //   "heading": "Google Developer Students Club (KGEC)",
  //   "text": "As Tech Co-Lead, led projects, hackathons, CTFs, and workshops.",
  //   "link": ""
  // },
  // {
  //   "heading": "KGEC Robotics Society",
  //   "text": "AI/ML Lead, developed ML models for robotics applications and organized events.",
  //   "link": ""
  // },
  {
    "heading": "GDSC KGEC & KGEC Robotics Society",
    "text": "Tech Co-Lead (GDSC) and AI/ML Lead (Robotics Society); led projects, hackathons, workshops, and ML work in robotics.",
    "link": ""
  },
  {
    "heading": "Google ExploreML Facilitator",
    "text": "Google ExploreML Facilitator (Batch-2): Led ML training with theory + hands-on sessions (with Google support), delivering workshops at Colman University (Israel), HKU MS, IERT Prayagraj, and others.",
    "link": ""
  },
  {
    "heading": "Open-Source Development Mentor",
    "text": "Mentored at GWOC'21, JWOC'22, Techsahead ICC'21, and multiple open-source events.",
    "link": ""
  },
  // {
  //   "heading": "NGA Work",
  //   "text": "Worked with Action for Better Community (ABC) with RIT on community projects.",
  //   "link": ""
  // }
]

export default {
  header,
  about,
  projects,
  skills,
  contact,
  experience,
  publications,
  blogs,
  highlights,
}
